import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProductAll(params) {
	return client.get("produk/list-all-produk", {
		params: params,
	});
}

function getProductMitra(params) {
	return client.get("produk/list-produk-stockist", {
		params: params,
	});
}

export default {
	getProductAll,
	getProductMitra,
};